// 生产环境开发者工具检测
(function () {
  'use strict'
  const customEnv = process.env.CUSTOM_ENV
  const nodeEnv = process.env.NODE_ENV
  const env = customEnv ||  nodeEnv
  console.log('env2222',env)
  if (env !== 'production') return
  const DEVTOOLS_THRESHOLD = 160
  let checkTimer = null
  let consoleTrapTimer = null
  let isTriggered = false

  const triggerDebug = () => {
    if (isTriggered) return
    isTriggered = true
    window.setTimeout(() => {
      isTriggered = false
    }, 100)
  }

  const checkDevtoolsOpened = () => {
    const widthDiff = window.outerWidth - window.innerWidth
    const heightDiff = window.outerHeight - window.innerHeight
    const devtoolsOpened =
      widthDiff > DEVTOOLS_THRESHOLD || heightDiff > DEVTOOLS_THRESHOLD

    if (devtoolsOpened) {
      triggerDebug()
    }
  }

  // 独立窗口 DevTools 不会改变当前页面尺寸，这里补一个控制台渲染探测
  const checkUndockedDevtools = () => {
    const devtoolsDetector = new Image()
    Object.defineProperty(devtoolsDetector, 'id', {
      get() {
        triggerDebug()
        return 'devtools-opened'
      }
    })
    // 控制台开启时，渲染对象会触发 getter；关闭时通常不会触发
    console.dir(devtoolsDetector)
  }

  checkDevtoolsOpened()
  checkTimer = window.setInterval(checkDevtoolsOpened, 1000)
  consoleTrapTimer = window.setInterval(checkUndockedDevtools, 1000)
  window.addEventListener('resize', checkDevtoolsOpened, true)

  window.addEventListener('beforeunload', () => {
    if (checkTimer) {
      clearInterval(checkTimer)
      checkTimer = null
    }
    if (consoleTrapTimer) {
      clearInterval(consoleTrapTimer)
      consoleTrapTimer = null
    }
  })
})()
